import React from "react";
import { Redirect } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import LoginSSO from "../pages/Authentication/LoginSSO";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import NewPwd from "../pages/Authentication/NewPassword";
import ExpirePasswordPage from "../pages/Authentication/ExpirePassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Companies
import EditCompany from "../pages/Companies/Company";

//Users
import Users from "../pages/Users/Users";
import NewUser from "../pages/Users/User";

//Profiles
import Profiles from "../pages/Profiles/Profiles";
import NewProfile from "../pages/Profiles/Profile";

//Groups
import Groups from "../pages/Groups/Groups";
import NewGroup from "../pages/Groups/Group";

//Departments
import Departments from "../pages/Departments/Departments";
import NewDepartment from "../pages/Departments/Department";

//Skills
import Skills from "../pages/Skills/Skills";
import NewSkill from "../pages/Skills/Skill";

//Exception
import Exceptions from "../pages/Exception/Exceptions";
import NewException from "../pages/Exception/Exception";

//Channels
import Channels from "../pages/Channels/Channels";
import NewChannel from "../pages/Channels/Channel";

//Operator Area
import OperatorArea from "../components/OperatorArea/index";

//Availability
import Availabilities from "../pages/Availabilities/Availabilities";
import Availability from "../pages/Availabilities/Availability";

//Tabs
import Tabs from "../pages/Tabs/Tabs";
import NewTab from "../pages/Tabs/Tab";

//Features
import Features from "../pages/Features/Features";

//Manager Panel
import ManagerPanel from "../components/ManagerPanel/index";

//Ticket Panel
import TicketPanel from '../components/TicketPanel/index';

//Real Automation
import RealAutomation from "../components/RealAutomation/index";

//Real Cashback
import RealCashback from "../components/RealCashback/index";

//Predefined Messages
import PredefinedMessages from "../pages/PredefinedMessages/PredefinedMessages";
import NewPredefinedMessage from "../pages/PredefinedMessages/PredefinedMessage";

//Scripts
import Scripts from "../pages/Scripts/Scripts";
import Script from "../pages/Scripts/Script";

//Automatic Messages
import AutomaticMessages from "../pages/AutomaticMessages/AutomaticMessages";
import NewAutomaticMessage from "../pages/AutomaticMessages/AutomaticMessage";

//Survey
import Surveys from "../pages/Survey/Surveys";
import NewSurvey from "../pages/Survey/Survey";

//Murals
import Murals from "../pages/Murals/Murals";
import NewMural from "../pages/Murals/Mural";
//Goals
import Goals from "../pages/Goals/Goals";
import NewGoal from "../pages/Goals/Goal";

//Edi Profile
import EditProfile from "../pages/EditProfile/EditProfile";

//Attachments Interaction
import AttachmentsInteraction from "../pages/AttachmentsInteraction";

//Aditional Field
import AdditionalFields from "../pages/AdditionalFields/AdditionalFields";
import AdditionalField from "../pages/AdditionalFields/AdditionalField";

//Reports
// import Reports from "../pages/Reports/Reports";

// Inner Authentication
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },

  //Companies
  {
    path: "/company",
    isPermissionProtected: true,
    permissionName: "company",
    component: EditCompany,
  },

  //Users
  {
    path: "/users/:idCompany",
    isPermissionProtected: true,
    permissionName: "user",
    component: Users,
  },
  {
    path: "/users",
    isPermissionProtected: true,
    permissionName: "user",
    component: Users,
  },
  {
    path: "/user/:idUser",
    isPermissionProtected: true,
    permissionName: "user",
    component: NewUser,
  },
  {
    path: "/user",
    isPermissionProtected: true,
    permissionName: "user",
    component: NewUser,
  },

  //Profiles
  {
    path: "/profiles/",
    isPermissionProtected: true,
    permissionName: "profile",
    component: Profiles,
  },
  {
    path: "/profile/:idProfile",
    isPermissionProtected: true,
    permissionName: "profile",
    component: NewProfile,
  },
  {
    path: "/profile",
    isPermissionProtected: true,
    permissionName: "profile",
    component: NewProfile,
  },

  //Groups
  {
    path: "/groups/",
    isPermissionProtected: true,
    permissionName: "group",
    component: Groups,
  },
  {
    path: "/group/:idGroup",
    isPermissionProtected: true,
    permissionName: "group",
    component: NewGroup,
  },
  {
    path: "/group",
    isPermissionProtected: true,
    permissionName: "group",
    component: NewGroup,
  },

  //Departments
  {
    path: "/departments/",
    isPermissionProtected: true,
    permissionName: "department",
    component: Departments,
  },
  {
    path: "/department/:idDepartment",
    isPermissionProtected: true,
    permissionName: "department",
    component: NewDepartment,
  },
  {
    path: "/department",
    isPermissionProtected: true,
    permissionName: "department",
    component: NewDepartment,
  },

  //Skills
  {
    path: "/skills/",
    isPermissionProtected: true,
    permissionName: "skill",
    component: Skills,
  },
  {
    path: "/skill/:idSkill",
    isPermissionProtected: true,
    permissionName: "skill",
    component: NewSkill,
  },
  {
    path: "/skill",
    isPermissionProtected: true,
    permissionName: "skill",
    component: NewSkill,
  },

  //Exceptions
  {
    path: "/exceptions/",
    isPermissionProtected: true,
    permissionName: "exception",
    component: Exceptions,
  },
  {
    path: "/exception/:idData",
    isPermissionProtected: true,
    permissionName: "exception",
    component: NewException,
  },
  {
    path: "/exception",
    isPermissionProtected: true,
    permissionName: "exception",
    component: NewException,
  },

  //Channels
  {
    path: "/channels/",
    isPermissionProtected: true,
    permissionName: "source",
    component: Channels,
  },
  {
    path: "/channel/:idChannel",
    isPermissionProtected: true,
    permissionName: "source",
    component: NewChannel,
  },
  {
    path: "/channel",
    isPermissionProtected: true,
    permissionName: "source",
    component: NewChannel,
  },

  //Operator Area
  { path: "/chats", component: OperatorArea },

  //Availability
  {
    path: "/availabilities",
    isPermissionProtected: true,
    permissionName: "availabilities",
    component: Availabilities,
  },
  {
    path: "/availability/:idAvailability",
    isPermissionProtected: true,
    permissionName: "availabilities",
    component: Availability,
  },
  {
    path: "/availability",
    isPermissionProtected: true,
    permissionName: "availabilities",
    component: Availability,
  },

  //Tabs
  {
    path: "/tabs/",
    isPermissionProtected: true,
    permissionName: "tabs",
    component: Tabs,
  },
  {
    path: "/tab/:idTab",
    isPermissionProtected: true,
    permissionName: "tabs",
    component: NewTab,
  },
  {
    path: "/tab",
    isPermissionProtected: true,
    permissionName: "tabs",
    component: NewTab,
  },

  //Features
  {
    path: "/features/",
    isPermissionProtected: true,
    permissionName: "feature",
    component: Features,
  },

  //Predefined Messages
  {
    path: "/predefined-messages",
    isPermissionProtected: true,
    permissionName: "predefined_message",
    component: PredefinedMessages,
  },
  {
    path: "/predefined-message/:idPredefinedMessage",
    isPermissionProtected: true,
    permissionName: "predefined_message",
    component: NewPredefinedMessage,
  },
  {
    path: "/predefined-message",
    isPermissionProtected: true,
    permissionName: "predefined_message",
    component: NewPredefinedMessage,
  },
  //Scripts
  {
    path: "/scripts",
    isPermissionProtected: true,
    permissionName: "scripts",
    component: Scripts,
  },
  {
    path: "/script/:idScript",
    isPermissionProtected: true,
    permissionName: "scripts",
    component: Script,
  },
  {
    path: "/script",
    isPermissionProtected: true,
    permissionName: "scripts",
    component: Script,
  },

  //Automatic Messages
  {
    path: "/automatic-messages",
    isPermissionProtected: true,
    permissionName: "automatic-messages",
    component: AutomaticMessages,
  },
  {
    path: "/automatic-message/:idAutomaticMessage",
    isPermissionProtected: true,
    permissionName: "automatic-messages",
    component: NewAutomaticMessage,
  },
  // {
  //   path: "/automatic-message",
  //   isPermissionProtected: true,
  //   permissionName: "automatic-messages",
  //   component: NewAutomaticMessage,
  // },

  //Survey
  {
    path: "/surveys",
    isPermissionProtected: true,
    permissionName: "survey",
    component: Surveys,
  },
  {
    path: "/survey/:idData",
    isPermissionProtected: true,
    permissionName: "survey",
    component: NewSurvey,
  },
  {
    path: "/survey",
    isPermissionProtected: true,
    permissionName: "survey",
    component: NewSurvey,
  },

  //Mural
  {
    path: "/murals",
    isPermissionProtected: true,
    permissionName: "mural",
    component: Murals,
  },
  {
    path: "/mural/:idData",
    isPermissionProtected: true,
    permissionName: "mural",
    component: NewMural,
  },
  {
    path: "/mural",
    isPermissionProtected: true,
    permissionName: "mural",
    component: NewMural,
  },
  //Goal
  {
    path: "/goals",
    isPermissionProtected: true,
    permissionName: "goal",
    component: Goals,
  },
  {
    path: "/goal/:idGoal",
    isPermissionProtected: true,
    permissionName: "goal",
    component: NewGoal,
  },
  {
    path: "/goal",
    isPermissionProtected: true,
    permissionName: "goal",
    component: NewGoal,
  },

  //Manager Panel
  {
    path: "/manager-panel",
    isPermissionProtected: true,
    permissionName: "manager",
    component: ManagerPanel,
  },

  //Ticket Panel
  {
    path: "/ticket-panel",
    isPermissionProtected: true,
    permissionName: "ticket_panel",
    component: TicketPanel,
  },

  //Real Automation
  {
    path: "/real-automation",
    isPermissionProtected: true,
    permissionName: "real_automation",
    component: RealAutomation,
  },
  //Real CashBack
  {
    path: "/real-cashback",
    isPermissionProtected: true,
    permissionName: "real_cashback",
    component: RealCashback,
  },

  //Edit Profile
  {
    path: "/edit-profile",
    isPermissionProtected: true,
    permissionName: "user-profile",
    component: EditProfile,
  },

  //aditional fields
  {
    path: "/additional-fields",
    isPermissionProtected: true,
    permissionName: "additional_fields",
    component: AdditionalFields,
  },
  {
    path: "/additional-field/:idAdditionalField",
    isPermissionProtected: true,
    permissionName: "additional_fields",
    component: AdditionalField,
  },
  {
    path: "/additional-field",
    isPermissionProtected: true,
    permissionName: "additional_fields",
    component: AdditionalField,
  },


  //Reports
  // {
  //   path: "/reports",
  //   // isPermissionProtected: true,
  //   // permissionName: "",
  //   component: Reports,
  // },

  //Attachments Interaction
  {
    path: "/attachments-interaction",
    component: AttachmentsInteraction,
  },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/loginSSO/:data", component: LoginSSO },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/reset-password/:token", component: NewPwd },
  { path: "/expire-password", component: ExpirePasswordPage },
  { path: "/register", component: Register },

  // Authentication Inner
  { path: "/auth-lock-screen", component: LockScreen },
];

export { authProtectedRoutes, publicRoutes };
